import { render, staticRenderFns } from "./OrgSettingsPlatformPreferences.vue?vue&type=template&id=47d8bed3&scoped=true&"
import script from "./OrgSettingsPlatformPreferences.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsPlatformPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8bed3",
  null
  
)

export default component.exports